import { QueryHookOptions, useQuery } from '@apollo/client';

import {
  GetBankDetailsDocument,
  GetBankDetailsQuery,
  GetBankDetailsQueryVariables,
} from 'common/hooks/useBankDetails/bankDetailsQuery.gql';

export const useBankDetails = (
  options?: QueryHookOptions<GetBankDetailsQuery, GetBankDetailsQueryVariables>,
) => {
  const query = useQuery(GetBankDetailsDocument, options);

  return query;
};
